// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-contact-js": require("gatsby-module-loader?name=component---src-pages-contact-js!/opt/build/repo/src/pages/contact.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js"),
  "component---src-pages-portfolio-js": require("gatsby-module-loader?name=component---src-pages-portfolio-js!/opt/build/repo/src/pages/portfolio.js"),
  "component---src-pages-resume-js": require("gatsby-module-loader?name=component---src-pages-resume-js!/opt/build/repo/src/pages/resume.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "contact.json": require("gatsby-module-loader?name=path---contact!/opt/build/repo/.cache/json/contact.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "portfolio.json": require("gatsby-module-loader?name=path---portfolio!/opt/build/repo/.cache/json/portfolio.json"),
  "resume.json": require("gatsby-module-loader?name=path---resume!/opt/build/repo/.cache/json/resume.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js